import { parseJSON } from '../../utils/FormatUtils';
import { WORKFLOW_FIELD_PROPERTY, WORKFLOW_FIELD_PROPERTY_PROP_MAPPER } from '../Constant';
import { WfTrackerField } from '../models/WfWorkflows';

export const getTrackerFieldProperty = (properties: string) => {
	let fieldProps = {};
	const propertyArray = properties.split(',');

	Object.values(WORKFLOW_FIELD_PROPERTY).forEach(property => {
		if (propertyArray.includes(property)) {
			const newProp = WORKFLOW_FIELD_PROPERTY_PROP_MAPPER[property];
			fieldProps = {
				...fieldProps,
				[newProp]: true,
			};
		}
	});

	return fieldProps;
};

export const convertTrackerFieldResponseToObject = (trackerFields: WfTrackerField[]) => {
	if (!(trackerFields ?? []).length) return;

	return trackerFields.reduce((result, field) => {
		result = {
			...result,
			[field.termField]: getTrackerFieldProperty(field.attribute),
		};

		return result;
	}, {});
};

export const getWorkflowTrackerFieldConfig = ({
	workflowConfig,
	componentName,
	field,
}: {
	workflowConfig: string | object;
	componentName: string;
	field: string;
}) => {
	if (!workflowConfig) return null;

	const config = typeof workflowConfig === 'string' ? parseJSON(workflowConfig) : workflowConfig;

	if (!config?.models) return null;

	const FIELD_MODIFIER = {
		r: 'read',
		w: 'write',
	};

	const fieldsConfig = config?.models.find(
		(config: any) => config.componentName === componentName
	)?.fields;

	if (!fieldsConfig?.length) return null;

	for (let index = 0; index < fieldsConfig.length; index++) {
		const element = fieldsConfig[index];
		const [fieldName, fieldModifier] = element.split(':');
		const modifiers = fieldModifier?.split('');
		let result: Record<string, boolean> = {};

		if (fieldName === field) {
			modifiers.forEach((modifier: string) => {
				result = {
					...result,
					[FIELD_MODIFIER[modifier as keyof typeof FIELD_MODIFIER]]: true,
				};
			});
			return result;
		}
	}
};